window.addEventListener("load", function () {
    const input = document.querySelector(".qty-container input");
    if(!input) return;

    const productIndividual = document.querySelector(".product").classList.contains("product--individual");
    const step = productIndividual ? 1 : 6;

    document.querySelector(".qty-container__minus").addEventListener("click", () => input.value = Math.max(step, input.value - step));
    document.querySelector(".qty-container__plus").addEventListener("click", () => input.value = parseInt(input.value) + step);

    if(!productIndividual) {
        input.addEventListener("change", function () {
            let value = parseInt(input.value);
    
            if(value % 6 !== 0) {
                value = Math.max(6, Math.ceil(value / 6) * 6);
                input.value = value;
            }
        });
    }
});